import React, { useEffect } from 'react';
import Header from '../components/Header';
import Profile from '../components/Profile';
import About from '../components/About';
import Experience from '../components/Experience';
import Projects from '../components/Projects';
import Contacts from '../components/Contacts';
import Footer from '../components/Footer';

function Landingpage() {
    useEffect(() => {
        // Cursor glow effect
        const glow = document.createElement('div');
        glow.id = 'cursor-glow';
        Object.assign(glow.style, {
            position: 'fixed',
            width: '600px',
            height: '600px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255,107,43,0.04) 0%, transparent 70%)',
            pointerEvents: 'none',
            zIndex: '0',
            transform: 'translate(-50%, -50%)',
            transition: 'left 0.9s cubic-bezier(.23,1,.32,1), top 0.9s cubic-bezier(.23,1,.32,1)',
            top: '50%',
            left: '50%',
        });
        document.body.appendChild(glow);

        const handleMouseMove = (e) => {
            glow.style.left = e.clientX + 'px';
            glow.style.top = e.clientY + 'px';
        };

        window.addEventListener('mousemove', handleMouseMove);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            if (document.body.contains(glow)) document.body.removeChild(glow);
        };
    }, []);

    return (
        <>
            <Header />
            <main>
                <Profile />
                <About />
                <Experience />
                <Projects />
                <Contacts />
            </main>
            <Footer />
        </>
    );
}

export default Landingpage;